import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

import { APP_CONFIG } from '../../../app.config';

@Component({
    selector: 'bucke-bicycle-footer',
    templateUrl: './bicycle-footer.component.html',
    styleUrl: './bicycle-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective],
})
export class BicyleFooterComponent {
    appConfig = APP_CONFIG;
}
